import React, { MouseEvent } from 'react';
import { Button, ButtonProps } from '@forgeglobal/design-framework';

export interface DropdownFieldActionProps extends ButtonProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

const DropdownFieldAction = ({
  children,
  onClick,
  ...rest
}: DropdownFieldActionProps) => {
  return (
    <Button
      data-test-id="delete-custom-question"
      variant="text"
      size="small"
      disableRipple
      onClick={(event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        onClick(event);
      }}
      {...rest}>
      {children}
    </Button>
  );
};

export default DropdownFieldAction;
